import { FC } from 'react';

import { ICON_STROKE_WIDTH } from 'views/components/UI/Icons/icons.constants';
import { IIconProps } from 'views/components/UI/Icons/icons.interface';

const PriorityCritical: FC<IIconProps> = ({
  size = '16',
  color = 'var(--sk-icon-danger)',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 13.0185L9.01015 9.0287C8.45226 8.47081 7.54774 8.47081 6.98985 9.0287L3 13.0185M13 7.30426L9.01015 3.31441C8.45226 2.75652 7.54774 2.75652 6.98985 3.31442L3 7.30426"
      stroke={color}
      strokeWidth={ICON_STROKE_WIDTH}
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);

export { PriorityCritical };
